import { useEffect, useState } from 'react';
import { API_URL } from 'src/environments/environment';
import { DEFAULT_HEADERS } from 'src/shared/constants';

type TBookedLessonType = 'past' | 'present' | 'all' | undefined;

const useBookedLessons = (params: { reFetch?: boolean | undefined, lessonType?: TBookedLessonType }) => {
  const { reFetch, lessonType } = params;
  const [bookedLessons, setBookedLessons] = useState<any[]>([]);
  const token = localStorage.getItem('token');

  useEffect(() => {
    const getData = async () => {
      const data = await fetch(`${API_URL}/lessons-schedule/all-booked-on-active-subs`, {
        method: 'GET',
        headers: {
          ...DEFAULT_HEADERS,
          Authorization: `Bearer ${token}`,
        },
      });
      const jsonData = await data.json();
      let bLessons = jsonData.filter((lesson: any) => new Date(lesson.bookingDate) >= new Date());
      if (lessonType === 'past') {
        bLessons = jsonData.filter((lesson: any) => new Date(lesson.bookingDate) < new Date());
      }
      if (lessonType === 'all') {
        bLessons = jsonData;
      }

      const compareFn = (a: number, b: number) => {
        if (a < b) {
          return -1;
        }
        if (a > b) {
          return 1;
        }
        return 0;
      };

      setBookedLessons(
        bLessons
          .sort((a: any, b: any) => compareFn(
            new Date(a.bookingDate)
              .getTime(),
            new Date(b.bookingDate)
              .getTime(),
          )),
      );
    };

    getData().then();
  }, [reFetch]);
  return { bookedLessons };
};

export default useBookedLessons;
